// Import CSS
import { Link } from "react-router-dom";
import "./styles.css"
import { Box, Tooltip } from "@mui/material";

const Logo = ({ src, size, destination}) => {
  return (
    <div>
      <Tooltip
        title={
          destination != null ? "Go to Homepage" : 
          null
        }
        placement="right"
        arrow
      >
        <Box>
          <Link to={destination}>
            <img
              src={src}
              alt="Logo"
              className={
                size === "sidebar" ? "logo-sidebar": "logo"} />
          </Link>
        </Box>
      </Tooltip>
    </div>
  );
};

export default Logo;